import styled from "@emotion/styled";
import {
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  tableCellClasses,
} from "@mui/material";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { useDispatch, useSelector } from "react-redux";
import { accountActions, cartActions } from "../actions";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import SearchSelector from "../controls/Autocomplete";
import CustomerList from "../components/CustomerList";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { makeRequest } from "../apis/makeRequest";
import { getCustomersBySalesPerson } from "../apis/backendRequests";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#225533",
    color: theme.palette.common.white,
    fontSize: 17,
  },
}));


export const CustomerSeller = () => {
  const account = useSelector((state) => state.account);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [autocompleteValue, setAutocompleteValue] = useState("");
  const [filterData, setFilterData] = useState([]);
  const [data, setData] = useState([]);

  useEffect(() => {
    if (!account.dynamicsId) {
      return;
    }
    const idSeller = !account.roles.includes("Admin Ventas") ? account.dynamicsId : ""
    makeRequest(
      () =>
        getCustomersBySalesPerson(idSeller, ""),
      (res) => setData(res.data)
    );
  }, [account.dynamicsId]);

  const handleLogOut = () => {
    dispatch(cartActions.clear());
    dispatch(accountActions.logOut());
    navigate("/");
  };

  const handleClick = (customer) => {
    if (!customer.hasOwnProperty("roles")) {
      customer.roles = "Cliente";
    }
    delete account.salesData;
    dispatch(cartActions.clear());
    dispatch(accountActions.changeDynamicsId(account, customer));
    navigate("/");
    return;
  };

  const onChange = (newValue) => {
    setAutocompleteValue(newValue);
    if (newValue) return setFilterData([newValue]);
    setFilterData([]);
  };

  const handleMenu = () => {
    navigate("/menu");
  };

  return (
    <Grid container spacing={2} flexDirection={"column"}>
      <Grid
        item
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
      >
        <Tooltip title="Usuario">
          <IconButton color="inherit" onClick={handleMenu} size="large">
            <AccountCircleIcon fontSize="large" />
          </IconButton>
        </Tooltip>
        <SearchSelector
          options={data}
          value={autocompleteValue}
          onChange={onChange}
        />
        <Tooltip title="Salir">
          <IconButton color="inherit" onClick={handleLogOut} size="large">
            <ExitToAppIcon />
          </IconButton>
        </Tooltip>
      </Grid>
      <Grid item>
        <TableContainer component={Paper}>
          <Table size="medium">
            <TableHead>
              <TableRow>
                <StyledTableCell align="center" colSpan={6}>
                  {account.fullName}
                </StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableCell align="center">N. Cliente </StyledTableCell>
                <StyledTableCell align="center">Descripción</StyledTableCell>
                <StyledTableCell align="center">Saldo</StyledTableCell>
                <StyledTableCell align="center">Acceder</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Object.keys(filterData).length !== 0
                ? filterData.map((customer, i) => (
                    <CustomerList
                      key={`${customer.dynamicsId} - ${i}`}
                      customer={customer}
                      handleClick={handleClick}
                    />
                  ))
                : data.map((customer, i) => (
                    <CustomerList
                      key={`${customer.dynamicsId} - ${i}`}
                      customer={customer}
                      handleClick={handleClick}
                    />
                  ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
};
